<template>
  <div v-wechat-title="title" style="background: #fff">
    <div class="topTitle">
      <img class="back" @click="$router.go(-1)" src="../assets/pingzi/back.png" alt="" />
      <div class="title">纠错详情</div>
    </div>
    <div class="main">
      <van-row class="rowlist">
        <van-col span="5" class="fr">客户名称：</van-col>
        <van-col span="19">
          <input type="text" class="inputText" :value="CompanyName" disabled>
        </van-col>
      </van-row>
      <van-row class="rowlist">
        <van-col span="5" class="fr">产品名称：</van-col>
        <van-col span="19">
          <input type="text" class="inputText" :value="ProductTitle" disabled>
        </van-col>
      </van-row>
      <van-row class="rowlist">
        <van-col span="5" class="fr">产品型号：</van-col>
        <van-col span="19">
          <input type="text" class="inputText" :value="ManuProductCode" disabled>
        </van-col>
      </van-row>
      <van-row class="rowlist">
        <van-col span="5" class="fr">车型ID：</van-col>
        <van-col span="7">
          <input type="text" class="inputText" :value="VehicleTypeId" disabled>
        </van-col>
        <van-col span="5" class="fr">产品品牌：</van-col>
        <van-col span="7">
          <input type="text" class="inputText" :value="ProductBrandName" disabled>
        </van-col>
      </van-row>
      <van-row class="rowlist">
        <van-col span="5" class="fr">vin码：</van-col>
        <van-col span="19">
          <input type="text" class="inputText" :value="vinCode" disabled>
        </van-col>
      </van-row>
      <van-row class="rowlist">
        <van-col span="5" class="fr">上传时间：</van-col>
        <van-col span="19">
          <input type="text" class="inputText" :value="errTime" disabled>
        </van-col>
      </van-row>
      
      <div class="remark">
        <p><span style="color:red">*</span>问题描述：</p>
        <textarea cols="30" rows="5" v-model="remark" placeholder="请填写不少于5个字的错误原因" :disabled="isEdit?false:true"></textarea>
      </div>

      <div class="uploadText" v-if="imgList.length>0">
        <p>上传图片(最多上传5张)</p>
      </div>
      <!-- <van-uploader v-if="isEdit" v-model="fileList" multiple :max-count="5" :max-size="5000 * 1024" @oversize="onOversize" :after-read="afterRead" preview-image="true"/> -->
       
      <div class="selectPhoto" v-if="isEdit">
        <!-- <div style="position:relative;width: 100%;">
          <van-field required readonly label="上传图片" value="" placeholder="(最多上传3张)"/>
        </div> -->

        <div style="width:90%;display: flex;">
          <div class="addImg disp-just-bet-ali-cen">
            <div style="width: 100%;">
              <div v-if="!isIOS && !img1" class="fileBtn" @click="android('imgOne')"></div>
              <input
                class="fileBtn"
                name="addImg"
                v-if="isIOS && !img1"
                ref="fileBtn1"
                @change="upload('fileBtn1','img1','IOS')"
                type="file"
                accept="image/*"
              >
              <img
                v-if="img1"
                class="chacha"
                @click="delImg('img1')"
                src="../assets/newicon/close.png"
              >
              <img v-if="!img1" src="../assets/newicon/upload.png" alt="">
              <img v-if="img1" alt="" ref="img1" class="img" :src="img1">
            </div>
          </div>
          <div v-if="img1" class="addImg disp-just-bet-ali-cen">
            <div style="width: 100%;">
              <div v-if="!isIOS && !img2" class="fileBtn" @click="android('imgTwo')"></div>
              <input
                class="fileBtn"
                v-if="isIOS && !img2"
                ref="fileBtn2"
                @change="upload('fileBtn2','img2','IOS')"
                type="file"
                accept="image/*"
              >
              <img
                v-if="img2"
                class="chacha"
                @click="delImg('img2')"
                src="../assets/newicon/close.png"
              >
              <img v-if="!img2" src="../assets/newicon/upload.png" alt="">
              <img v-if="img2" alt="" ref="img2" class="img" :src="img2">
            </div>
          </div>
          <div v-if="img2" class="addImg disp-just-bet-ali-cen">
            <div style="width: 100%;">
              <div v-if="!isIOS && !img3" class="fileBtn" @click="android('imgThree')"></div>
              <input
                class="fileBtn"
                v-if="isIOS && !img3"
                ref="fileBtn3"
                @change="upload('fileBtn3','img3','IOS')"
                type="file"
                accept="image/*"
              >
              <img
                v-if="img3"
                class="chacha"
                @click="delImg('img3')"
                src="../assets/newicon/close.png"
              >
              <img v-if="!img3" src="../assets/newicon/upload.png" alt="">
              <img v-if="img3" alt="" ref="img3" class="img" :src="img3">
            </div>
          </div>
          <div v-if="img3" class="addImg disp-just-bet-ali-cen">
            <div style="width: 100%;">
              <div v-if="!isIOS && !img4" class="fileBtn" @click="android('imgFour')"></div>
              <input
                class="fileBtn"
                v-if="isIOS && !img4"
                ref="fileBtn4"
                @change="upload('fileBtn4','img4','IOS')"
                type="file"
                accept="image/*"
              >
              <img
                v-if="img4"
                class="chacha"
                @click="delImg('img4')"
                src="../assets/newicon/close.png"
              >
              <img v-if="!img4" src="../assets/newicon/upload.png" alt="">
              <img v-if="img4" alt="" ref="img4" class="img" :src="img4">
            </div>
          </div>
          <div v-if="img4" class="addImg disp-just-bet-ali-cen">
            <div style="width: 100%;">
              <div v-if="!isIOS && !img5" class="fileBtn" @click="android('imgFive')"></div>
              <input
                class="fileBtn"
                v-if="isIOS && !img5"
                ref="fileBtn5"
                @change="upload('fileBtn5','img5','IOS')"
                type="file"
                accept="image/*"
              >
              <img
                v-if="img5"
                class="chacha"
                @click="delImg('img5')"
                src="../assets/newicon/close.png"
              >
              <img v-if="!img5" src="../assets/newicon/upload.png" alt="">
              <img v-if="img5" alt="" ref="img5" class="img" :src="img5">
            </div>
          </div>
          
        </div>
        <!-- 弹框 -->
        <van-popup v-model="show" round>
          <div class="typeBox disp-just-aro-ali-cen">
            <div>
              拍照上传
              <input
                v-if="imgOne"
                ref="pictureB_file1"
                capture="camera"
                class="pictureB_file"
                accept="image/*"
                type="file"
                name="pictureA_file"
                @change="upload('pictureB_file1','img1')"
              >
              <input
                v-if="imgTwo"
                ref="pictureB_file2"
                capture="camera"
                class="pictureB_file"
                accept="image/*"
                type="file"
                name="pictureA_file"
                @change="upload('pictureB_file2','img2')"
              >
              <input
                v-if="imgThree"
                ref="pictureB_file3"
                capture="camera"
                class="pictureB_file"
                accept="image/*"
                type="file"
                name="pictureA_file"
                @change="upload('pictureB_file3','img3')"
              >
              <input
                v-if="imgThree"
                ref="pictureB_file4"
                capture="camera"
                class="pictureB_file"
                accept="image/*"
                type="file"
                name="pictureA_file"
                @change="upload('pictureB_file4','img4')"
              >
              <input
                v-if="imgThree"
                ref="pictureB_file5"
                capture="camera"
                class="pictureB_file"
                accept="image/*"
                type="file"
                name="pictureA_file"
                @change="upload('pictureB_file5','img5')"
              >
            </div>
            <div>
              选图上传
              <input
                v-if="imgOne"
                ref="pictureC_file1"
                class="pictureC_file"
                @change="upload('pictureC_file1','img1')"
                type="file"
                name="pictureA_file"
              >
              <input
                v-if="imgTwo"
                ref="pictureC_file2"
                class="pictureC_file"
                @change="upload('pictureC_file2','img2')"
                type="file"
                name="pictureA_file"
              >
              <input
                v-if="imgThree"
                ref="pictureC_file3"
                class="pictureC_file"
                @change="upload('pictureC_file3','img3')"
                type="file"
                name="pictureA_file"
              >
              <input
                v-if="imgFour"
                ref="pictureC_file4"
                class="pictureC_file"
                @change="upload('pictureC_file4','img4')"
                type="file"
                name="pictureA_file"
              >
              <input
                v-if="imgFive"
                ref="pictureC_file5"
                class="pictureC_file"
                @change="upload('pictureC_file5','img5')"
                type="file"
                name="pictureA_file"
              >
            </div>
          </div>
        </van-popup>
      </div>
      <div class="imgList" v-else>
        <img  v-for="(item, index) of imgList" :index="index" :item="item" :key="index" :src="item">
      </div>

      <template v-if="!isEdit">
        <div class="errResult">处理结果：{{HandDetails}}</div>
        <div class="errResult">处理详情：{{HandlerType}}</div>
      </template>
    </div>
    <div class="btns" v-if="isEdit">
      <van-button type="primary" size="large" @click="subData">上传</van-button>
      <van-button type="primary" size="large" @click="handleBlackPage">关闭</van-button>
      <van-button type="primary" size="large" @click="toErrorCorrectionHistory">历史纠错</van-button>
    </div>
    
  </div>
  
</template>

<script>
import Vue from "vue";
import { List, Toast } from "vant";
import util from "../utils/util";
import api from "../services/api";
import $ from "../utils/axiosp";
import {
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Col,
  Row,
  Sticky,
  Search,
  DropdownMenu,
  DropdownItem,
  Uploader
} from "vant";

Vue.use(GoodsAction);
Vue.use(GoodsActionButton);
Vue.use(GoodsActionIcon);
Vue.use(Col);
Vue.use(Row);
Vue.use(List);
Vue.use(Toast);
Vue.use(Sticky);
Vue.use(Search);
Vue.use(Uploader);

export default {
  name: "errorCorrection",
  components: {  },
  computed: {
    
  },
  data() {
    return {
      fileList:[],
      isEdit:true,
      title:this.$route.meta.title,
      CompanyName:'',//客户名称
      ProductTitle:'',//产品名称
      ProductId:'',//产品ID
      BrandId:'',//品牌ID
      ProductBrandName:'',//品牌名称
      ManuProductCode:'',//产品型号
      VehicleTypeId:'',//车型ID
      vinCode:'',//vin码
      errTime:'',//纠错时间
      remark:'',

      imgOne: false, //弹框
      imgTwo: false, //弹框
      imgThree: false, //弹框
      imgFour: false, //弹框
      imgFive: false, //弹框
      img1: "", 
      img2: "", 
      img3: "", 
      img4: "",
      img5: "",
      show: false,
      isIOS: false,
      addImg: [],
      imgList:[],
      Status:'',
      HandDetails:'',
      HandlerType:''
    };
  },
  async created() {
    
  },
  mounted() {
    this.phoneType();
    if(this.$route.query.type=='view'){
      this.isEdit = false;
      console.log(this.$route.query.imgList);
      if(this.$route.query.imgList){
        this.imgList = this.$route.query.imgList.split(",");
      }
      this.title = '历史纠错';
    }else{
      this.title = this.$route.meta.title;
    }
    this.CompanyName = JSON.parse(localStorage.getItem('allinfo')).UserName;
    this.ProductTitle = this.$route.query.ProductTitle;
    this.ProductBrandName = this.$route.query.ProductBrandName;
    this.ManuProductCode = this.$route.query.ManuProductCode;
    this.VehicleTypeId = this.$route.query.VehicleTypeId;
    this.vinCode = this.$route.query.vinCode;
    this.errTime = this.$route.query.errTime;
    this.ProductId = this.$route.query.ProductId;
    this.BrandId = this.$route.query.BrandId;
    this.remark = this.$route.query.remark;
    this.Status = this.$route.query.Status;
    this.HandlerType = this.$route.query.HandlerType;
    this.HandDetails = this.$route.query.HandDetails
  },
  methods: {
    // afterRead(file) {
    //   console.log('fileList',this.fileList);
    //   console.log('file',file);
    //   var that = this;
    //   $.reqPost("User/UpLoadProcess", file, that).then(
    //         res => {
    //           console.log(res.Data)
    //           that[d] = util.getStoObj('allinfo').DomainUrl +  res.Data;
    //           console.log(that[d],'222' )
    //           Toast("上传成功");
    //         }
    //   );
    // },
    // onOversize(file) {
    //   console.log(file);
    //   Toast('文件大小不能超过 5M');
    // },
    delImg(which) {
      
      var that = this;
      that[which] = "";
    },
    handleBlackPage() {
      this.$router.go(-1)
    },
    toErrorCorrectionHistory(){
      this.$router.push("/errorCorrectionHistory");
    },
    android(which) {
      this.show = !this.show;
      if (which != 1) {
        this[which] = true;
      } else {
        this.imgOne = false;
        this.imgTwo = false;
        this.imgThree = false;
        this.imgFour = false;
        this.imgFive = false;
      }
    },
    // 提交
    subData(){
      console.log(this.remark);
      if(this.remark==undefined||this.remark==''){
        Toast("请填写问题描述信息后再上传");
        return
      }else if(this.remark.length<5){
        Toast("请填写不少于5个字的错误原因");
        return
      }else  if(this.remark.length>30){
        Toast("错误原因不能多于30个字");
        return
      }
      let arr = [
        {Pic: this.img1},
        {Pic: this.img2},
        {Pic: this.img3},
        {Pic: this.img4},
        {Pic: this.img5}
      ];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].Pic) {
          this.addImg.push(arr[i].Pic);
        }
      }
      let ImageURL = this.addImg.toString();
      this.$parent.Loading(true);
      $.reqPost("RobotErrorCorrection/Save", {
        VehicleTypeId:this.VehicleTypeId,
        Vin:this.vinCode,
        ProductId:this.ProductId,
        ProductName:this.ProductTitle,
        BrandId:this.BrandId,
        BrandName:this.ProductBrandName,
        ModelName:this.ManuProductCode,
        ImageURL:ImageURL,
        Content:this.remark
      }).then(res => {
        Toast(res.Reason);
        this.$parent.Loading(false);
        setTimeout(() => {
          this.handleBlackPage()
        }, 500);
      }).catch((err) => {
        Toast(err || "系统繁忙，请您稍后再试。");
        this.$parent.Loading(false);
      });
    },
    // 上传图片
    upload(c, d, f) {
       "use strict";
      var that = this;
      
      var $c = that.$refs[c],
        $d = that.$refs[d],
        file = $c.files[0],
        reader = new FileReader();
      
      console.log(file.type.includes('video'));
      if(file.type.includes('video')){
        Toast('请上传图片格式的文件');
        return 
      }
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        // 
        var dataURl = reader.result;
        // 安卓机的时候走这一步
        if (f != "IOS") {
          that.android(1);
        }
        
        if (file.size / Math.pow(1024, 2) > 5) {
          Toast({
            message: "不能上传大小超过5MB的图片",
            duration: 1300
          });
        } else {
          // 上传图片
          var formdata = new FormData();
          formdata.append("pic", file);
          
          // that.loadShow = true;
          $.reqPost("User/UpLoadProcess", formdata, that).then(res => {
              // that.addImg.arr.push(res.FileImgUrl);
              // that.loadShow = false;
              console.log(res.Data)
              that[d] = util.getStoObj('allinfo').DomainUrl +  res.Data;
              console.log(that[d],'222' )
              // $d.setAttribute("src", res.FileImgUrl);
              Toast("上传成功");
            }
          );
        }
      };
    },
    
    // 判断机型
    phoneType() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        //如果是安卓手机，就弹框是选择图片还是拍照
        
        this.isIOS = false;
      } else {
        //如果是苹果系统，就还照之前的样子去操作即可
        
        this.isIOS = true;
      }
    },
  }
};
</script>

<style lang="scss">
  .main .van-uploader__preview-image,.main .van-uploader__upload{
    width: 1.25rem;
    height: 1.25rem;
  }
  .main .van-uploader__preview-delete{
    width: 16px;
    height: 16px;
  }
  .selectPhoto .van-field__label {
    width: 1.12rem;
    font-size:0.24rem
  }
</style>
<style lang="scss" scoped>
  .main{
    font-size: 0.24rem;
    padding:1rem 10px 10px 10px;
    .rowlist{
      display: flex;
      align-items: center;
      padding:5px 0
    }
    .fr{
      text-align: right
    }
  }
  .back{
      float: left;
      width:0.4rem;
      margin-top: 0.2rem;
  }
  .title{
    font-size:0.3rem
  }
  .btns{
    display:flex;
    justify-content: center;
    position: fixed;
    bottom:20px;
    left:0;
    width:100%;
    .van-button{
      margin:0 10px
    }
  }
  .inputText{
    width: 100%;
    height: 25px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    padding:0 5px;
    font-size:0.24rem
  }
  .uploadText{
    margin:10px 0
  }
  .remark{
    p{
      margin-top:5px;
      margin-bottom: 5px
    }
    textarea{
      width:100%;
      border:1px solid #ccc;
      padding:5px;
      box-sizing: border-box
    }
  }
  .imgList img{
    width:20%
  }
  .errResult{
    margin-bottom:5px
  }
  .fileBtn {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    outline: none;
    background-color: transparent;
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    // border:1rpx solid red;
    opacity: 0;
    z-index: 1;
  }

  .typeBox {
    width: 5rem;
    height: 3rem;
    background: white;
  }

  .typeBox div {
    width: 1.5rem;
    height: 0.76rem;
    background: #4fae54;
    text-align: center;
    border-radius: 0.2rem;
    line-height: 0.76rem;
    color: white;
    font-size: 0.26rem;
    position: relative;
  }

  .pictureB_file,
  .pictureC_file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    outline: none;
    background-color: transparent;
    filter: alpha(opacity=0);
    -moz-opacity: 0;
    -khtml-opacity: 0;
    opacity: 0;
    z-index: 1;
  }

  .van-picker__cancel,
  .van-picker__confirm {
    color: #4fae54 !important;
  }

  

  .van-field__control {
    width: 100% !important;
    overflow: hidden;
    text-align: right !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.28rem;
    line-height: 0.75rem;
    // padding-right: 0.45rem !important;
  }

  .radioBox {
    width: 100%;
    height: 1.22rem;
    position: relative;
  }

  .van-radio-group {
    display: flex;
    justify-content: flex-end;
  }

  .van-radio {
    width: 2.5rem;
    font-size: 0.3rem;
    height: 0.8rem;
  }

  .van-radio__icon {
    height: 0.4rem !important;
    font-size: 0.2rem !important;
  }

  .van-radio__icon .van-icon {
    width: 0.4rem !important;
    height: 0.4rem !important;
    padding-top: 0.06rem !important;
    margin-left: 0.2rem !important;
    box-sizing: border-box;
    border: 0.02rem solid #e5e5e5 !important;
    font-size: 0.25rem !important;
  }

  .selectPhoto{
    margin-top:15px;
    .addImg {
      width: 1.2rem;
      // border: 1px solid;
      margin-bottom: 0.15rem;
      // padding-left: 0.3rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      position: relative;
      margin-right:0.2rem;
      img {
        width: 1.2rem;
        height: 1.2rem;
      }
    }
  }
  .chacha {
    width: 0.5rem !important;
    height: 0.5rem !important;
    position: absolute !important;
    right: -0.25rem !important;
    top: -0.25rem !important;
    background-color: white;
    border-radius: 50%;
  }
  .van-cell {
    line-height: 0.6rem !important;
  }
</style>